import {
  Box,
  Button,
  Fab,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import PoprchModal from "../payment/popSearch";
import { ToDate } from "../../common/toDate";
import {
  getFirstDateOfCurrentMonthPayloadFormate,
  getLastDateOfCurrentMonthPayloadFormat,
} from "../../utils/commonUtils";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { useSelector } from "react-redux";
import { VendorRegistration } from "../vendorRegistration/vendorRegistration";
import Quatation from "../quetation/question";
// import { addPuchaseOrder, getAllProdct } from "./purchaseManagmentApi";
// import AddPuchaseOrder from "./purchaseModalAdd.jsx";
import AddIcon from "@mui/icons-material/Add";
import CardPayment from "../payment/cardPayment.jsx";
import {
  getAllotation,
  getAllProdct,
} from "../purchaseManagment/purchaseManagmentApi.js";
import AddPuchaseOrder from "../purchaseManagment/purchaseModalAdd.jsx";
import { routePath } from "../../constants/routePath.jsx";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import html2pdf from "html2pdf.js";
import {
  Card,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import dayjs from "dayjs";
import { getBillerTAndCByType } from "../purchaseManagment/termsAndConditionsApi.js";
export const QuetatioinPage = () => {
  const [open, setOpen] = useState(false);
  const receptRef = useRef();

  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab
  );
  const infoD = useSelector((state) => state.reducer.detail);
  const userDetail = useSelector((state) => state.reducer.userDetail);
  const [collection, setCollection] = useState([]);
  const cardKet = {
    persnoalInf: [
      {
        key: "quotationNumber",
        label: "Quotation No.",
        color: "#bb4a9b",
      },
      {
        key: "customerName",
        label: "Customer Name",
        color: "#bb4a9b",
      },

      {
        key: "customerAddress",
        // color: "black",
        label: "Address ",
        splitF: { target: "T", index: 0 },
      },
      {
        key: "quotationDate",
        // color: "black",
        label: "Date",
      },
      {
        key: "validTill",
        // color: "black",
        label: "Valid Till",
      },

      {
        key: "payableAmount",
        // color: "black",
        label: "Payable Amount",
      },

      // {
      //   keys: ["paymentPercentage", "salaryorPercentage"],
      //   color: "#3695B6",
      //   label: "Payment Percentage",
      // },
    ],
    educationalDetail: [
      {
        key: "courseName",
        label: "Course Name",
      },
      {
        key: "courseDetails",
        label: "Component Name",
      },
      {
        key: "durationInYear",
        label: "Duration In Year",
      },
      {
        key: "percentage",
        label: "Percentage",
      },

      {
        key: "grade",
        label: "grade",
      },
      {
        key: "institute",
        label: "institute",
      },
      {
        key: "university",
        label: "university",
      },
    ],

    incentrive: [
      {
        key: "incentiveName",
        label: "Incentive Name",
      },
      {
        key: "minimumValue",
        label: "Minimum Value",
      },
      {
        key: "maximumValue",
        label: "Maximum Value",
      },

      {
        key: "percentage",
        label: "percentage",
      },
    ],
    Deductions: [
      {
        key: "componentName",
        label: "Component Name",
      },
      {
        key: "amount",
        label: "Amount",
      },

      {
        key: "percentage",
        label: "Percentage",
      },
    ],
  };
  const [quaotaionModal, setQuotationModal] = useState(false);

  // 10 16 15 17 18
  useEffect(() => {
    console.log("purchase data businessChooseTab?.value", userDetail);
    if (userDetail && userDetail?.profileId) {
      let val = userDetail?.profileId?.split("?")[1];
      getAllotation(
        {
          billerId: val.split("=")[1]?.replace(/\D/g, ""),
        },
        (res) => {
          console.log("res getall product ", res?.data);
          setCollection([...res?.data]);
        }
      );
    }
  }, [userDetail, quaotaionModal]);

  const [modaldata, setModalData] = useState(null);
  const [modaldataQt, setModalDataQt] = useState(null);
  const [quotationData, setQuotationData] = useState(null);
  // alert("$$$$$$$$$$$ " +modaldataQt);
  const [termAndCondition, setTermAndCondition] = useState("");

  useEffect(() => {
    const fetchTermAndCondition = async () => {
      try {
        const res = await getBillerTAndCByType("Quotation");
        const detailss = res?.data?.data?.details;
        setTermAndCondition(detailss);
      } catch (error) {}
    };
    fetchTermAndCondition();
  }, []);
  console.log("$$$$$$$$$", modaldataQt);

  useEffect(() => {
    console.log("info d info ", infoD);
  }, [infoD]);
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "long", year: "numeric" };
    return date.toLocaleDateString("en-GB", options).replace(/ /g, "-");
  };

  const htmlToPDF = async (componentRef, fileName = "Quotation.pdf") => {
    const element = componentRef.current;
    const options = {
      margin: 0.5,
      filename: fileName,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    try {
      const pdfBlob = await html2pdf()
        .from(element)
        .set(options)
        .output("blob");
      return pdfBlob;
    } catch (error) {
      console.error("Error generating PDF", error);
      return null;
    }
  };

  const handleDownload = async (item) => {
    setModalDataQt(item);
    console.log(modaldataQt);

    // Wait for modalData to render and DOM to update
    await new Promise((resolve) => setTimeout(resolve, 200));

    const fileName =
      item?.purchaseOrderNumber?.replaceAll("/", "_") || "Quotation";
    const blob = await htmlToPDF(receptRef, `${fileName}.pdf`);

    if (blob) {
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${fileName}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  };

  return (
    <Box>
      {quaotaionModal && (
        <Box>
          <Quatation
            quotationData={quotationData}
            setQuotationData={setQuotationData}
            setQuotationModal={setQuotationModal}
          />
        </Box>
      )}

      {!quaotaionModal && (
        <>
          <Grid
            px={2}
            pb={4}
            container
            sx={{
              paddingTop: "10px",
              // paddingLeft: "10px",
              backgroundColor: "#E3E3FF",
              fontFamily: "'Montserrat', sans-serif",
            }}
          >
            <Grid container>
              {/* <DynamicBreadcrumbs /> */}
              <Grid
                item
                xs={6}
                sm={9}
                md={8}
                lg={10}
                alignItems="center"
                justifyContent="space-between"
                sx={{
                  background:
                    "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
                  padding: "10px",
                  borderRadius: "5px",
                  color: "#01008B",
                  marginBottom: "20px",
                }}
              >
                {/* <Grid> */}
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: 500,
                  }}
                >
                  Quotation
                </Typography>
                {/* </Grid> */}
              </Grid>

              <Grid item xs={6} sm={3} md={4} lg={2}>
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    height: {lg:"40px", md:'35px', sm:'35px', xs: "35px" },
                    backgroundColor: "#14008B",
                    // px: {xs:3, sm:3},
                    fontSize: { xs: "12px", sm: "13px", md: "14px" },
                  }}
                  onClick={() => {
                    setQuotationModal(true);
                    // setOpen(true);
                    // Navigate(routePath.Quatation)
                  }}
                  size="small"
                  color="primary"
                  aria-label="add"
                >
                  Add Quotation
                  <AddIcon
                    sx={{
                      ml: 1,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  />
                </Button>
              </Grid>
            </Grid>
            {/* <DynamicBreadcrumbs /> */}
            {/* <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "right",
                alignItems: "center",
              }}
            >
              <Fab
                onClick={() => {
                  setQuotationModal(true);
                  // setOpen(true);
                  // Navigate(routePath.Quatation)
                }}
                sx={{
                  textTransform: "capitalize",
                  width: {
                    xs: "100%",
                    sm: "auto",
                  },
                  // p: "10px",
                  whiteSpace: "nowrap",
                }}
                size="small"
                color="primary"
                variant="extended"
                aria-label="add"
              >
                Add Quatation
                <AddIcon />
              </Fab>
            </Grid> */}
            {/* <h1>hi</h1> */}
            {/* {collection?.map((item, index) => (
                <Grid item xs={4} key={index}>
                  <CardPayment
                    item={item}
                    setOpen={(data) => {}}
                    setModalData={(quatation) => {
                      console.log("upupupupup ", quatation);
                      let obj = {};
                      Object.keys(quatation).map((key, index) => {
                        if (quatation[key] && quatation[key] != "null") {
                          obj[key] = quatation[key];
                        } else {
                          obj[key] = "";
                        }
                      });
                      console.log("objobjobjobj", obj);

                      // setModalData({...obj,
                      // });
                      setModalData(item);
                  setQuotationModal(true);
                      
                      setQuotationData(item)
                      // setModalDataT(obj);
                      // setOpenT(true);
                    }}
                    cardKet={cardKet?.persnoalInf}
                  />
                </Grid>
              ))} */}
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid container>
                <Grid container item xs={12}>
                  <Box
                    sx={{
                      width: "100%",
                      backgroundColor: "#fff",
                      borderRadius: "10px",
                      height: "96vh",
                      overflow: "auto",
                      display: "flex",
                      flexDirection: "column",
                      // padding: 1,
                    }}
                  >
                    <Box
                      sx={{
                        minWidth: "1050px",
                        width: "max-content",
                        p: 2,
                      }}
                    >
                      <Box
                        sx={{
                          width: "100%",
                          height: "83vh",
                          overflowY: "auto",
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        {/* Table Header */}
                        <Box
                          sx={{
                            display: "flex",
                            borderBottom: "1.5px solid black",
                            alignItems: "center",
                            paddingBottom: 1,
                            paddingLeft: "20px",
                            paddingRight: "60px",
                            // gap: 3,
                          }}
                        >
                          {cardKet.persnoalInf.map((col, idx) => (
                            <Box
                              key={idx}
                              sx={{
                                flex: 1,
                                color: "#01008B",
                                fontWeight: 500,
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                textAlign: "center",
                              }}
                            >
                              {col.label}
                            </Box>
                          ))}
                        </Box>
                        {/* <Divider
                                sx={{
                                  width: "90%",
                                  // marginRight:"44rem",
                                  background: (theme) => theme.palette.primary.main,
                                }}
                              /> */}
                        {/* Table Body */}
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "5px",
                            paddingLeft: 2,
                            paddingRight: 2,
                          }}
                        >
                          {collection.map((quatation, index) => (
                            <Box
                              key={index}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                background: "#E8E8FF",
                                borderRadius: "10px",
                                padding: "12px 0px",
                                paddingLeft: "30px",
                                paddingRight: "10px",
                                cursor: "pointer",
                                gap: 2,
                                ":hover": {
                                  backgroundColor: "#dcdcff",
                                },
                              }}
                              onClick={() => {
                                // setModalData((quatation) => {
                                console.log("upupupupup ", quatation);
                                let obj = {};
                                Object.keys(quatation).map((key, index) => {
                                  if (
                                    quatation[key] &&
                                    quatation[key] != "null"
                                  ) {
                                    obj[key] = quatation[key];
                                  } else {
                                    obj[key] = "";
                                  }
                                });
                                console.log("objobjobjobj", obj);

                                // setModalData({...obj,
                                // });
                                setModalData(quatation);
                                setModalDataQt(quatation);

                                setQuotationModal(true);

                                setQuotationData(quatation);
                                // setModalDataT(obj);
                                // setOpenT(true);
                                // });
                                setQuotationModal(true);
                              }}
                            >
                              {cardKet.persnoalInf.map((col, idx) => (
                                <Box
                                  key={idx}
                                  sx={{
                                    flex: 1,
                                    color: "black",
                                    fontSize: {
                                      xs: "12px",
                                      sm: "13px",
                                      md: "15px",
                                    },
                                    textAlign:
                                      col.key === "payableAmount"
                                        ? "Right"
                                        : "",

                                    pl:
                                      col.key === "customerName"
                                        ? { xs: 2, sm: 2, md: 4, lg: 3 }
                                        : col.key === "customerAddress"
                                          ? { xs: 6, sm: 4, md: 4, lg: 3 }
                                          : col.key === "quotationNumber"
                                            ? { xs: 2, sm: 2, md: 4, lg: 3 }
                                            : 0,
                                    pr:
                                      col.key === "payableAmount"
                                        ? { xs: 2, sm: 2, md: 4, lg: 2 }
                                        : 0,
                                    fontWeight: "500",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {col.splitF
                                    ? (quatation?.[col.key]?.split(
                                        col.splitF.target,
                                      )?.[col.splitF.index] ?? "-")
                                    : ["quotationDate", "validTill"].includes(
                                          col.key,
                                        )
                                      ? formatDate(quatation?.[col.key])
                                      : (quatation?.[col.key] ?? "-")}
                                </Box>
                              ))}
                              <Box display="flex" justifyContent="center">
                                <IconButton
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDownload(quatation);
                                    console.log(
                                      "Download clicked for item:",
                                      // item
                                    );
                                  }}
                                  sx={{
                                    p: 0,
                                  }}
                                >
                                  <FileDownloadIcon
                                    sx={{ fontSize: "25px", color: "#01008B" }}
                                  />
                                </IconButton>
                              </Box>
                              {/* ...BUTTON */}
                            </Box>
                          ))}
                        </Box>
                        {/* .pdf */}
                        {modaldataQt &&
                          (() => {
                            // const vendor = getVendorDetails(
                            //   modaldataQt?.vendorId
                            // );
                            return (
                              <Card
                                sx={{
                                  maxWidth: 800,
                                  mx: "auto",
                                  p: 2,
                                  position: "fixed",
                                  top: 0,
                                  left: 0,
                                  opacity: 0,
                                  pointerEvents: "none",
                                  zIndex: -999,
                                  fontFamily: "Arial",
                                }}
                              >
                                <Box
                                  ref={receptRef}
                                  sx={{ position: "relative", mx: "auto" }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "22px",
                                      fontWeight: "bold",
                                      color: "#0C1E5B",
                                      letterSpacing: 1,
                                      textAlign: "center",
                                    }}
                                  >
                                    QUOTATION
                                  </Typography>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      mb: 2,
                                    }}
                                  >
                                    {/* Left: Logo */}
                                    <Box
                                      sx={{ width: "100px", height: "100px" }}
                                    >
                                      <img
                                        src={userDetail?.logoPath}
                                        alt="Logo"
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "contain",
                                        }}
                                      />
                                    </Box>

                                    {/* Center: Title */}
                                    <Box>
                                      <Typography
                                        sx={{
                                          fontWeight: "bold",
                                          fontSize: 16,
                                          color: "#0C1E5B",
                                        }}
                                      >
                                        {userDetail?.myBusinessName ||
                                          "Business Name"}
                                      </Typography>

                                      <Typography sx={{ fontSize: 14 }}>
                                        {userDetail?.billerAddress ||
                                          "Business Address"}
                                      </Typography>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          gap: 2,
                                          alignItems: "center",
                                          justifyContent: "center",
                                          mt: 1,
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            display: "flex",
                                            gap: 1,
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              fontWeight: "bold",
                                              color: "#0C1E5B",
                                              fontSize: 14,
                                            }}
                                          >
                                            Mobile:
                                          </Typography>
                                          <Typography sx={{ fontSize: 14 }}>
                                            {userDetail?.mobileNumber || "-"}
                                          </Typography>
                                        </Box>

                                        <Box sx={{ display: "flex", gap: 1 }}>
                                          <Typography
                                            sx={{
                                              fontWeight: "bold",
                                              color: "#0C1E5B",
                                              fontSize: 14,
                                            }}
                                          >
                                            GSTIN:
                                          </Typography>
                                          <Typography sx={{ fontSize: 14 }}>
                                            {userDetail?.gstRegistrationNumber ||
                                              "-"}
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box sx={{ display: "flex", gap: 1 }}>
                                        <Typography
                                          sx={{
                                            fontWeight: "bold",
                                            color: "#0C1E5B",
                                            fontSize: 14,
                                          }}
                                        >
                                          Email:
                                        </Typography>
                                        <Typography sx={{ fontSize: 14 }}>
                                          {userDetail?.mailID1 || "-"}
                                        </Typography>
                                      </Box>
                                    </Box>

                                    {/* Right: empty box to balance layout */}
                                    <Box
                                      sx={{ width: "80px", height: "80px" }}
                                    />
                                  </Box>

                                  <Divider
                                    sx={{
                                      borderBottom: "6px solid black",
                                      my: 2,
                                    }}
                                  />

                                  <Grid container spacing={2}>
                                    {/* Left: Supplier Details */}
                                    <Grid item xs={6}>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 2,
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            fontWeight: "bold",
                                            color: "#0C1E5B",
                                          }}
                                        >
                                          Quotation No:
                                        </Typography>
                                        <Typography>
                                          {modaldataQt?.quotationNumber}
                                        </Typography>
                                      </Box>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 2,
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            fontWeight: "bold",
                                            color: "#0C1E5B",
                                          }}
                                        >
                                          Quotation Date:
                                        </Typography>
                                        <Typography>
                                          {modaldataQt?.quotationDate
                                            ? dayjs(
                                                modaldataQt.quotationDate,
                                              ).format("DD-MMM-YYYY")
                                            : ""}
                                        </Typography>
                                      </Box>

                                      <Typography
                                        sx={{
                                          fontWeight: "bold",
                                          mt: 2,
                                          color: "#0C1E5B",
                                        }}
                                      >
                                        BILL TO:
                                      </Typography>
                                      <Typography
                                        sx={{
                                          fontWeight: "bold",
                                          mt: 2,
                                          color: "#0C1E5B",
                                        }}
                                      >
                                        {modaldataQt?.customerName}
                                      </Typography>
                                      <Box>
                                        {/* <Typography
                                          sx={{
                                            fontWeight: "bold",
                                            color: "#0C1E5B",
                                          }}
                                        >
                                          {"-"}
                                        </Typography>
                                        <Typography>{"-"}</Typography> */}
                                        <Typography>
                                          {modaldataQt?.customerAddress || "-"}
                                        </Typography>
                                        <Typography>
                                          Mobile:{" "}
                                          {modaldataQt?.mobileNumber || "-"}
                                        </Typography>
                                        {/* <Typography>GSTIN: {"-"}</Typography> */}
                                      </Box>
                                    </Grid>

                                    {/* Right: Purchaser Details */}
                                    <Grid item xs={6}>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 2,
                                          mt: 3,
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            fontWeight: "bold",
                                            color: "#0C1E5B",
                                          }}
                                        >
                                          Expiry Date:
                                        </Typography>
                                        <Typography>
                                          {modaldataQt?.validTill
                                            ? dayjs(
                                                modaldataQt.validTill,
                                              ).format("DD-MMM-YYYY")
                                            : ""}
                                        </Typography>
                                      </Box>

                                      <Typography
                                        sx={{
                                          fontWeight: "bold",
                                          mt: 2,
                                          color: "#0C1E5B",
                                        }}
                                      >
                                        SHIP TO:
                                      </Typography>
                                      <Typography
                                        sx={{
                                          fontWeight: "bold",
                                          mt: 2,
                                          color: "#0C1E5B",
                                        }}
                                      >
                                        {modaldataQt?.customerName}
                                      </Typography>
                                      <Typography>
                                        {modaldataQt?.customerAddress || "-"}
                                      </Typography>
                                      <Typography></Typography>

                                      {/* <Box sx={{ mt: 2 }}>
                                        <Typography
                                          sx={{
                                            fontWeight: "bold",
                                            color: "#0C1E5B",
                                          }}
                                        >
                                          {userDetail?.myBusinessName}
                                        </Typography>
                                        <Typography>
                                          {" "}
                                          {userDetail?.billerAddress}
                                        </Typography>
                                        <Typography>
                                          Mobile: {userDetail?.mobileNumber}
                                        </Typography>
                                        <Typography>
                                          GSTIN:{" "}
                                          {userDetail?.gstRegistrationNumber}
                                        </Typography>
                                      </Box> */}
                                    </Grid>
                                  </Grid>

                                  <Divider
                                    sx={{
                                      color: "#0C1E5B",
                                      fontWeight: "bold",
                                      borderBottom: "2px solid black",
                                      mt: 2,
                                    }}
                                  />

                                  {/* Table Section */}
                                  <TableContainer
                                    component={Paper}
                                    elevation={0}
                                  >
                                    <Table
                                      sx={{ minWidth: 650 }}
                                      aria-label="purchase order table"
                                    >
                                      <TableHead>
                                        <TableRow>
                                          {[
                                            "ITEM",
                                            "HSN",
                                            "QTY",
                                            "RATE",
                                            "GST",
                                            "TOTAL",
                                          ].map((header) => (
                                            <TableCell
                                              key={header}
                                              sx={{
                                                color: "#0C1E5B",
                                                fontWeight: "bold",
                                                borderBottom: "2px solid black",
                                                ...(header === "HSN" && {
                                                  pl: 25,
                                                }), // Add padding-left to QTY only
                                              }}
                                            >
                                              {header}
                                            </TableCell>
                                          ))}
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {(modaldataQt?.items || []).map(
                                          (row, index) => {
                                            const gst =
                                              (row?.cgst || 0) +
                                              (row?.sgst || 0) +
                                              (row?.igst || 0);

                                            return (
                                              <TableRow
                                                key={index}
                                                sx={{
                                                  color: "#0C1E5B",
                                                  borderBottom:
                                                    "2px solid black",
                                                }}
                                              >
                                                <TableCell>
                                                  {row.itemDescription}
                                                </TableCell>
                                                <TableCell sx={{ pl: 25 }}>
                                                  -
                                                </TableCell>
                                                <TableCell>
                                                  {row.quantity}
                                                </TableCell>

                                                <TableCell>
                                                  {row.unitPrice}
                                                </TableCell>

                                                <TableCell>
                                                  {gst.toFixed(2)}
                                                </TableCell>
                                                <TableCell>
                                                  {row.totalPrice}
                                                </TableCell>
                                              </TableRow>
                                            );
                                          },
                                        )}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>

                                  {/* Total */}
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",

                                      mt: 4,
                                      gap: 3,
                                      // mx: 2,
                                    }}
                                  >
                                    {/* box 1 */}

                                    <Box sx={{ mt: 2 }}>
                                      <Typography
                                        sx={{
                                          fontWeight: "bold",
                                          color: "#0C1E5B",
                                          mb: 1,
                                        }}
                                      >
                                        BANK DETAILS
                                      </Typography>

                                      {[
                                        {
                                          label: "Name:",
                                          value: "Palace The Salon",
                                        },
                                        {
                                          label: "IFSC Code:",
                                          value: userDetail?.ifsc,
                                        },
                                        {
                                          label: "Account No:",
                                          value: userDetail?.accountNumber,
                                        },
                                      ].map((item, index) => (
                                        <Box
                                          key={index}
                                          sx={{
                                            display: "flex",
                                            mb: 0.5,
                                            gap: 3,
                                          }}
                                        >
                                          {/* Label */}
                                          <Box sx={{ width: "120px" }}>
                                            <Typography
                                              sx={{
                                                fontWeight: 500,
                                                // color: "#0C1E5B",
                                              }}
                                            >
                                              {item.label}
                                            </Typography>
                                          </Box>

                                          {/* Value */}
                                          <Typography>{item.value}</Typography>
                                        </Box>
                                      ))}
                                    </Box>

                                    {/* box 2 */}
                                    <Box sx={{ mt: 2 }}>
                                      {[
                                        {
                                          label: "TAXABLE AMOUNT:",
                                          value: modaldataQt?.billAmount,
                                        },
                                        {
                                          label: "GST:",
                                          value:
                                            (modaldataQt?.sgst ?? 0) +
                                              (modaldataQt?.cgst ?? 0) ||
                                            modaldataQt?.igst ||
                                            0,
                                        },
                                        {
                                          label: "TOTAL AMOUNT:",
                                          value: modaldataQt?.payableAmount,
                                        },
                                      ].map((item, index) => (
                                        <Box
                                          key={index}
                                          sx={{
                                            display: "flex",
                                            mb: 0.5,
                                            gap: 3,
                                          }}
                                        >
                                          {/* Label Column */}
                                          <Box
                                            sx={{
                                              width: "200px",
                                              textAlign: "right",
                                              pr: 1,
                                            }}
                                          >
                                            <Typography
                                              sx={{
                                                fontWeight: "bold",
                                                color: "#0C1E5B",
                                              }}
                                            >
                                              {item.label}
                                            </Typography>
                                          </Box>

                                          {/* Value Column */}
                                          <Box sx={{ minWidth: "80px" }}>
                                            <Typography>
                                              Rs. {item.value.toFixed(2)}
                                            </Typography>
                                          </Box>
                                        </Box>
                                      ))}
                                    </Box>
                                  </Box>
                                  <Typography
                                    sx={{
                                      fontWeight: "bold",
                                      color: "#0C1E5B",
                                      mt: 2,
                                    }}
                                  >
                                    NOTE
                                  </Typography>
                                  <Typography>
                                    {modaldataQt?.message || "-"}
                                  </Typography>

                                  {/* T&C */}
                                  <Box sx={{ mt: 4 }}>
                                    <Typography
                                      sx={{
                                        fontWeight: "bold",
                                        color: "#0C1E5B",
                                      }}
                                    >
                                      TERMS AND CONDITIONS
                                    </Typography>
                                    <Typography>{termAndCondition}</Typography>
                                  </Box>
                                </Box>
                              </Card>
                            );
                          })()}
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>

            <AddPuchaseOrder
              getAllData={() => {
                if (userDetail && userDetail?.profileId) {
                  let val = userDetail?.profileId?.split("?")[1];
                  getAllProdct(
                    {
                      billerId: val.split("=")[1]?.replace(/\D/g, ""),
                    },
                    (res) => {
                      console.log("res getall product ", res?.data);
                      setCollection([...res?.data]);
                    },
                  );
                }
              }}
              modaldata={modaldata}
              open={open}
              setOpen={setOpen}
              setModalData={setModalData}
            />
          </Grid>
        </>
      )}
      {/* {businessChooseTab?.value == "VenderRegistration" &&
          <VendorRegistration />} */}
      {/* {businessChooseTab?.value == "Quotation" &&
          <Quatation />} */}
    </Box>
  );
};
